import { useEffect, useState } from 'react';
import { Container } from './BrokenImage.styles';

interface IBrokenImage {
  src: string;
  brokenSrc: string;
}

export const BrokenImage = ({ src, brokenSrc, ...rest }: IBrokenImage) => {
  const [imgSrc, setImgSrc] = useState(src);
  const handleError = () => {
    setImgSrc(brokenSrc);
  };

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  return <Container src={imgSrc} {...rest} onError={handleError} />;
};
